import { NgModule } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { IonicStorageModule } from '@ionic/storage-angular';

import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { MainModule } from './main/main.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { CookieConsentModule } from '@shared/components/cookie-consent/cookie-consent.module';
import { APP_BASE_HREF } from '@angular/common';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

function getBaseHref() {
  let href = '/';
  const W = window;
  const WL = W.location;
  if (WL.host === 'vivenhealth.com' || WL.host === 'www.vivenhealth.com') {
    try {
      const arr = W['base-href'].split('/');
      href = arr.slice(0, 3).join('/');
    } catch (e) {
      console.log(e.message);
    }
  }
  return href;
}

export function createTranslateLoader(http: HttpClient, constants: ConstantsService) {
  void constants;
  const src = '/api/geti18nfile/';
  return new TranslateHttpLoader(http, src, '.json');
}

import {
  HttpRequestsService,
  SplashScreenService,
  UserProgressService,
  CurrentUserService,
  UserStorageService,
  SweepstakeService,
  NavigationService,
  ConstantsService,
  StorageService,
  ConfigService,
  UserResolver,
  AuthGuard,
} from '@shared/services';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    MainModule,
    CookieConsentModule,
    CoreModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, ConstantsService],
      },
    }),
    IonicStorageModule.forRoot(),
  ],
  providers: [
    SplashScreenService,
    HttpRequestsService,
    NavigationService,
    UserProgressService,
    CurrentUserService,
    UserStorageService,
    SweepstakeService,
    ConstantsService,
    StorageService,
    ConfigService,
    UserResolver,
    AuthGuard,
    Meta,
    { provide: APP_BASE_HREF, useValue: getBaseHref() },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
